import { z } from "zod";

/**
 * KRİTİK UYARI POLİTİKASI (CLOS-1260 — Bekleyen İşlemler Kanonu §19).
 *
 * ### ⚠ Dört alan, kanonun yönetici ekranıyla birebir
 *
 * §19 şunu gösteriyor:
 *
 * ```text
 * Bilgilendir: ☑ Sözleşme Yöneticisi ☑ Ana Ekip ☐ Birlikte Çalışan Ekipler
 * Kritik olduğunda ayrıca: ☑ Organizasyon Yönetimi
 * ```
 *
 * ⚠ Serbest bir "alıcı listesi" alanı YOK: kanonun gelişmiş ayarları (belirli departman,
 * rol filtresi, açık kullanıcı, kanal override) bu dilimde kapsam dışı. Serbest alan
 * koysaydık, ekranın göstermediği bir yeteneği veri modelinde varmış gibi taşırdık.
 */
export const alertPolicySchema = z.strictObject({
  informContractManager: z.boolean(),
  informLeadTeam: z.boolean(),
  informCollaboratingTeams: z.boolean(),
  escalateToOrgManagementOnCritical: z.boolean(),
});
export type AlertPolicy = z.infer<typeof alertPolicySchema>;

/**
 * ⚠ Güncelleme şeması OKUMA şemasıyla aynı ve bu bilinçli: kısmi güncelleme (PATCH
 * semantiği) "gönderilmeyen alan ne olacak?" sorusunu doğururdu. Yönetici ekranı dört
 * kutuyu birden gösteriyor; gönderdiği şey de politikanın tamamı.
 */
export const updateAlertPolicySchema = alertPolicySchema;
export type UpdateAlertPolicyInput = z.infer<typeof updateAlertPolicySchema>;

/** Politikanın görünümü: değerler + varsayılandan sapılıp sapılmadığı. */
export type AlertPolicyView = AlertPolicy & {
  /** ⚠ `false` = kiracı hiç dokunmamış, varsayılanlar geçerli. Ekran bunu söyleyebilmeli. */
  customized: boolean;
};
